(function() { window.GUID_0ef867cb_f690_45eb_97ae_653a2917d96c = { getGuid: function() { return "0ef867cb-f690-45eb-97ae-653a2917d96c"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class HorizontalScroller extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                let me = this;
                me.controlId = params[0];
                me.$control = $("#" + params[0]); //contient le Id
                me.$control.addClass("horizontal-scroller");
                me.$control.wrapInner("<div class='horizontal-scroller-content'></div>");
                me.$content = me.$Control.children(".horizontal-scroller-content");
                let $scrollToElement = me.$Control.find(".scroll-to");
                $(document).ready(function () {
                    me.ScrollToItem($scrollToElement);
                    me.$Control.css("opacity", 1);
                });
                //CS.Helper.RenderingHelper.IsRendered(me.$Control, function () {
                //    me.ScrollToItem($scrollToElement);
                //    me.$Control.css('opacity', 1);
                //});
            }
            OnDispose() {
                this.$content.off("scroll." + this.controlId);
                this.$Control.remove();
            }
            OnBindEvents() {
                let scrolled = false;
                let me = this;
                me.$content.offon("scroll." + me.controlId, () => {
                    if (scrolled) {
                        return;
                    }
                    scrolled = true;
                    CS.Analytics.Event("HorizontalScroller", "Scroll", me.ControlId);
                });
            }
            ScrollToItem($element) {
                if ($element.length > 0) {
                    this.$content.scrollLeft($element.position().left - this.$Control.position().left - 30);
                }
            }
        }
        Controls.HorizontalScroller = HorizontalScroller;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=horizontal-scroller.js.map
